import { apiUrl } from "./appConfig";

const AUTH_KEY = "mycgps_auth";

export function getAuth() {
  const raw = localStorage.getItem(AUTH_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAuth(auth) {
  localStorage.setItem(AUTH_KEY, JSON.stringify(auth));
  window.dispatchEvent(new Event("auth-changed"));
}

export function clearAuth() {
  localStorage.removeItem(AUTH_KEY);
  window.dispatchEvent(new Event("auth-changed"));
}

export async function logoutAndClearAuth() {
  try {
    await authFetch("/api/auth/logout", { method: "POST" });
  } catch {
    // 忽略网络异常，确保前端可退出
  } finally {
    clearAuth();
  }
}

export function getToken() {
  const auth = getAuth();
  return auth?.token || "";
}

export function isLoggedIn() {
  const auth = getAuth();
  if (!auth?.token || !auth?.expiresAt) return false;
  return new Date(auth.expiresAt).getTime() > Date.now();
}

export function getRole() {
  const auth = getAuth();
  return auth?.role || "";
}

export function isAdmin() {
  return getRole().toLowerCase() === "admin";
}

export function isOperator() {
  return getRole().toLowerCase() === "operator";
}

export async function authFetch(url, options = {}) {
  const token = getToken();
  const headers = {
    ...(options.headers || {}),
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
  return fetch(apiUrl(url), { ...options, headers });
}
